<template>
  <div>
    <div
      v-for="(drinks, subCategoryId) in drinksGroupedBy(drinksBySubCategory)"
      :key="subCategoryId"
    >
      <h3 v-if="hasSubCategory(subCategoryId)" class="subcategory-name">
        {{ getSubCategoryName(subCategoryId) }}
      </h3>

      <template v-for="(drink, index) in filterEmptyStock(drinks)">
        <li
          :key="index"
          class="product-row"
          :style="{ 'background-color': '#FFFFFF' }"
        >
          <div class="flex-wrapper">
            <h4 class="product-name" :style="{ color: listItemNameColorTheme }">
              {{ translate("name", drink) }}
            </h4>

            <div class="product-meta">
              <!-- Base price-->
              <div v-if="validBasePrice(drink)">
                <AddToCartDrink
                  size="base"
                  :isAdmin="isAdmin"
                  :drink="drink"
                ></AddToCartDrink>
              </div>

              <!-- CUP price-->
              <div v-if="validCupPrice(drink)">
                <AddToCartDrink
                  size="copa"
                  :isAdmin="isAdmin"
                  :drink="drink"
                ></AddToCartDrink>
              </div>

              <!-- CUBATA price-->
              <div v-if="validCubataPrice(drink)">
                <AddToCartDrink
                  size="cubata"
                  :isAdmin="isAdmin"
                  :drink="drink"
                ></AddToCartDrink>
              </div>

              <!-- BOTELLA price-->
              <div v-if="validBottlePrice(drink)">
                <AddToCartDrink
                  size="botella"
                  :isAdmin="isAdmin"
                  :drink="drink"
                ></AddToCartDrink>
              </div>

              <!-- CHUPITO price-->
              <div v-if="validShotPrice(drink)">
                <AddToCartDrink
                  size="chupito"
                  :isAdmin="isAdmin"
                  :drink="drink"
                ></AddToCartDrink>
              </div>
            </div>
          </div>

          <div
            v-if="drink.description"
            class="description"
            :style="{ color: listItemDescriptionColorTheme }"
          >
            {{ translate("description", drink) }}
          </div>
          <div v-if="drink.isAllowProductStory">
            <v-btn
              class="mt-3 gradient-border"
              outlined
              small
              fab
              color="white"
              @click="storyDialogAction(drink.productStory)"
            >
              <v-icon style="color: black !important;">mdi-camera</v-icon>
            </v-btn>
          </div>
        </li>
      </template>
    </div>
    <StoryDialog
      v-if="storyDialog && storyUrl !== ''"
      :openDialog.sync="storyDialog"
      :storyUrl="storyUrl"
    />
  </div>
</template>

<script>
import AddToCartDrink from "../../cart/AddToCartDrink";
import StoryDialog from "@/components/admin/product/productstory/StoryDialog";

export default {
  name: "ListDrinks",
  props: {
    categoryName: String,
    drinksBySubCategory: Array,
    subCategories: Array,
    isAdmin: Boolean
  },
  components: {
    AddToCartDrink,
    StoryDialog
  },
  data() {
    return {
      storyDialog: false,
      storyUrl: ""
    };
  },
  methods: {
    storyDialogAction(videoUrl) {
      if (videoUrl !== "" && videoUrl !== undefined) {
        this.storyUrl = videoUrl;
        this.storyDialog = true;
      }
    },
    filterEmptyStock(drinks) {
      return drinks && drinks.filter(x => x.stock > 0);
    },
    drinksGroupedBy(products, key = "sub_category_id") {
      return this.arrayGroupBy(products, key);
    },
    hasSubCategory(id) {
      return this.getSubCategoryName(id) !== "";
    },
    getSubCategoryName(id) {
      const subCategory = this.subCategories.find(
        subCategory => id === subCategory.id
      );
      return subCategory ? subCategory.name : "";
    },
    validBasePrice(product) {
      return (
        product.price !== undefined &&
        product.price !== "" &&
        product.price !== null
      );
    },
    validCupPrice(product) {
      return (
        product.price_cup !== undefined &&
        product.price_cup !== "" &&
        product.price_cup !== null
      );
    },
    validBottlePrice(product) {
      return (
        product.price_bottle !== undefined &&
        product.price_bottle !== "" &&
        product.price_bottle !== null
      );
    },
    validShotPrice(product) {
      return (
        product.price_shot !== undefined &&
        product.price_shot !== "" &&
        product.price_shot !== null
      );
    },
    validCubataPrice(product) {
      return (
        product.price_cubata !== undefined &&
        product.price_cubata !== "" &&
        product.price_cubata !== null
      );
    }
  }
};
</script>
